export default function setIsMobile(state, isMobile) {
  Object.assign(state, { isMobile });
}
